class CalendarNavigationFilters {
  constructor(Authentication) {
    'ngInject';

    this.Authentication = Authentication;
  }

  getMergedFilters(tabDefinition, cachedFilters) {
    let eventTypes = [];

    if (!this.hasTypeFilter(tabDefinition.filter)) {
      eventTypes = cachedFilters.eventTypes || [];
    } else {
      const typeFilterUnion = (cachedFilters.eventTypes || []).filter((f) =>
        tabDefinition.filter.eventTypes.includes(f)
      );
      eventTypes = typeFilterUnion.length ? typeFilterUnion : tabDefinition.filter.eventTypes;
    }

    const mergedFilters = {
      ...tabDefinition.filter,
      ...cachedFilters,
      ...{ eventTypes },
    };

    if (tabDefinition.myEvents) {
      mergedFilters.userIds = [this.Authentication.user.id];
    }

    return mergedFilters;
  }

  getAvailableTypeFilters(tabDefinition, typeFilters) {
    return typeFilters.filter(
      (filter) =>
        !this.hasTypeFilter(tabDefinition.filter) ||
        tabDefinition.filter.eventTypes.includes(filter.id)
    );
  }

  addTabDefaultFilters(filter, tabObj, customConfig) {
    if (!filter) {
      return;
    }
    let valuesWithDefaults = {};
    if (tabObj?.filter) {
      Object.keys(filter).forEach((key) => {
        valuesWithDefaults[key] = (!filter[key].length && tabObj.filter[key]) || filter[key];
      });
    } else {
      valuesWithDefaults = { ...filter };
    }
    // special treatment for filters thar depend on controller values
    if (customConfig) {
      if (
        !valuesWithDefaults?.locationIds.length &&
        customConfig.notAllLocations &&
        customConfig.locations
      ) {
        valuesWithDefaults.locationIds = customConfig.locations.map((item) => item.id);
      }

      if (
        !valuesWithDefaults?.positionIds.length &&
        customConfig.notAllPositions &&
        customConfig.positions
      ) {
        valuesWithDefaults.positionIds = customConfig.positions.map((item) => item.id);
      }
    }
    return valuesWithDefaults;
  }

  hasTypeFilter(filter) {
    return filter && filter.eventTypes?.length;
  }
}

export default CalendarNavigationFilters;
